import React, { useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import WeexModal from "../comps/weexModais/WeexModal";
import CampanhaService from "../services/CampanhaService";

function SeletorCampanha() {
	const [erro, setErro] = useState(null);
	const [codigo, setCodigo] = useState("");
	const service = new CampanhaService();
	const [processando, setProcessando] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory();
	let { code } = useParams();

	const [clienteEscolhido, setClienteEscolhido] = useState('')
	const [campanhaEscolhida, setCampanhaEscolhida] = useState('')

	
	const [campanhasPublicas, setCampanhas] = useState([])

	useEffect(() => {
        service.obterCampanhas((erro, sucesso) => {
            if(erro){
                console.log(erro)
            }
            if(sucesso){
				console.log(sucesso)
                setCampanhas(sucesso)
            }
        })
     }, [])

	 const [clienteCampanha, setCliente] = useState('')


	const i18n = useStore().getState().i18n;

	const [erroMsg, setErroMsg] = useState({
		isWrong: false,
		titulo: "",
		mensagem: "",
		voltar: false,
	});

	useEffect(() => {
		if (!processando) {
			setProcessando(true);
			service.definirCampanha(code, (erro, sucesso) => {
				if (erro) {
					setErro(erro);
					return;
				}
				if (sucesso) {
					dispatch({ type: "campanha/selecionar" });
					history.push("/");
				}
			});
		}
	}, []);

	const handleRedirectEvent = (event) => {
		const { value } = event.target;
		setCodigo(value);
		setErroMsg({ isWrong: false });
	};

	const onChangeCliente = (e) => {
		const {value} = e.target;

		if(value === ""){
			setCliente('')
			setClienteEscolhido("")
			setCodigo('')
			return
		}

		const dadosCliente = campanhasPublicas[value].cliente.campanhas
		if(dadosCliente.length > 1){
			setCliente(dadosCliente)
			setClienteEscolhido(value)
			setCodigo('')
		}else{
			console.log("entrei aqui")
			setCliente('')
			setClienteEscolhido(value)
			setCodigo(dadosCliente[0].code)
			console.log("codigo")
			console.log(codigo)
		}
		
	};

	const onChangeCampanha = (e) => {
		const {value} = e.target;

		if(value === ""){
			setCampanhaEscolhida("")
			setCodigo('')
			return
		}
		setCodigo(value)
		setCampanhaEscolhida(value)
	}

	const submitRedirectEvent = (event) => {
		event.preventDefault();
		service.definirCampanha(codigo, (erro, sucesso) => {
			if (erro) {
				setErroMsg({
					isWrong: true,
					titulo: i18n.message(
						"redirecionamento.erro.aoEncontrarCampanha.titulo",
						"Campanha não encontrada"
					),
					mensagem: i18n.message(
						"redirecionamento.erro.aoEncontrarCampanha.mensagem",
						"Escolha uma campanha antes de prosseguir."
					),
					voltar: true,
				});
			}
			if (sucesso) {
				setErroMsg({ isWrong: false });
				history.push("/");
			}
		});
	};

	const callbackModal = () => {
		if (erroMsg.isWrong === true) {
			setErroMsg({ isWrong: false });
			// history.push(`/`);
		}
	};

	return (
		<>
			{erroMsg.isWrong === true ? (
				<WeexModal
					callback={callbackModal}
					visivel={erroMsg !== null}
					titulo={erroMsg.titulo}
					conteudo={erroMsg.mensagem}
				/>
			) : null}
			{erro !== null ? (
				<>
					<div>
						<img src="../logo.png" alt="logo-weex" />
					</div>
					<div className="weex_user_container">
						<form style={{ width: "100%" }} onSubmit={submitRedirectEvent}>
							<div className="field redireciona-campanha-field">
							
							<label>Em qual empresa você trabalha ? </label>	
						<select value={clienteEscolhido} style={{width: "100%"}} onChange={onChangeCliente}>
                        <option value="">Selecione a sua empresa</option>
                        {
                          campanhasPublicas?.map((clientes, index) => {
                            return (
                              <>
                              <option key={clientes.cliente.uuid}
                                      value={index}
                                >
                                        
                                {clientes.cliente.name}

                              </option>
                              </> 
                            )
                          })
                        }
                      </select>
							</div>
							{
								clienteCampanha ? <div className="field redireciona-campanha-field"
							
								>

							<label>De qual campanha esta participando ? </label>				
							<select value={campanhaEscolhida} style={{width: "100%"}} onChange={onChangeCampanha}>
							<option value="">Selecione uma campanha</option>
							{	
							  clienteCampanha.map((campanha, index) => {
								  
								return (
								  <>
								  <option key={campanha.uuid}
										  value={campanha.code}
									>
											
									{campanha.name}
	
								  </option>
								  </> 
								)
							  })
							}
						  </select>
								</div>: ""
							}
							
							
							<div className="redireciona-campanha-container-btn">
								{
									codigo ? <button className="weex-button" disabled={codigo.length === 0}>
									{i18n.message(
										"redirecionamento.redirecionar.botao",
										"Entrar"
									)}
								</button>: ""
								}
								
							</div>
						</form>
					</div>
				</>
			) : (
				<></>
			)}
		</>
	);
}

export default SeletorCampanha;
